<ng-container *ngIf="catalogList && catalogList.length > 1">

<p-dropdown *ngIf="!changeAction"
  [options]="catalogList"
  optionLabel="catalogName"
  [(ngModel)]="selectedCatalog"
  [filter]="true"
  (onChange)="onCatalogChanged($event)"
  [style]="{ minWidth: '130px', width: '200px' }">
</p-dropdown>

<p-dropdown *ngIf="changeAction"
  [options]="catalogList"
  optionLabel="catalogName"
  [(ngModel)]="selectedCatalog"
  placeholder="Select a Catalog"
  [filter]="true"
  (onChange)="onChanged.emit($event)"
  [style]="{ minWidth: '130px', width: '200px' }">
</p-dropdown>

</ng-container>



